/**
 * Route prefixes of the admin area (soci, configurazioni + onboarding, superadmin).
 * Inside these routes the global view selector is hidden and pages are scoped by
 * the admin scope store (ConfigSwitcher) instead of the view selection.
 */
export const ADMIN_ROUTE_PREFIXES = ['/members', '/configurations', '/dati', '/users', '/cer'];

export function isAdminPath(pathname: string): boolean {
	return ADMIN_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
